/*    
<summary>
   This functional common component provides us custom DateTime form Field  and has error handler that shows 
   validation error. 
   Developer:Aashish Singh, Created Date:08-Mar-2023
</summary>
<returns>Returns JSX</returns>
*/
import * as React from 'react';
import dayjs from 'dayjs';
import TextField from '@mui/material/TextField';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import Stack from '@mui/material/Stack';
import { useField } from 'formik';
import { formatMessage } from '../../translations/format-message';
import config from '../../helpers/config-helper';
import { DATE_TIME_FORMAT_WITHOUT_SECONDS } from '../../constants/common-constants';

const appConfig = config();
const dateTimeFormat =  appConfig.REACT_APP_DATE_TIME_FORMAT;

export default function FormikDateTimeFieldMUI(props:any) {
  const { disabled, min, max , label, errClassName} = props;
  const [ field, meta, helpers ] = useField(props);
  const { touched, error } = meta;

  return (
    <>
    <LocalizationProvider dateAdapter={AdapterDayjs}>
     <Stack spacing={3}>
        <DateTimePicker
          renderInput={(params:any) => <TextField {...params} />}
          label={label ? label : ""}
          value={field.value ? field.value:""}
          ampm={false}
          minutesStep={props?.minutesStep ? props?.minutesStep : undefined}
          views={['year', 'day', 'hours', 'minutes']}
          inputFormat={DATE_TIME_FORMAT_WITHOUT_SECONDS}
          onChange={(newValue:any) => {
            helpers.setValue(newValue);
          }}
          minDateTime={ min ? dayjs(min): undefined}
          maxDateTime={ max ? dayjs(max): undefined}
          disabled={props.disabled}
        />
      </Stack>
    </LocalizationProvider>
    {(error && <span data-testid="testError" className={`text-danger errorMessage ${errClassName ? errClassName : ""}`}>{formatMessage(error)}</span>)}
    </>
  );
}
